(function () {
  'use strict';

  var CONFIG = window.spaceMarketingConfig || {};
  var STORAGE_KEY = 'space-marketing-attribution-v1';
  var CHIIKI_VIEW_KEY = 'space-chiiki-view:' + window.location.pathname;
  var PHONE_CLICK_DEDUP_KEY = 'space-phone-click-sent';
  var MAIL_CLICK_DEDUP_KEY = 'space-mail-click-sent';
  var FORM_SUBMIT_DEDUP_KEY = 'space-form-submit-sent';
  var TRACKED_QUERY_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'gclid',
    'gad_source',
    'gbraid',
    'wbraid',
    'msclkid'
  ];

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {
      return false;
    }
    return true;
  }

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      return false;
    }
    return true;
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function trimString(value, maxLength) {
    if (value == null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || 100);
  }

  function readStoredAttribution() {
    var parsed = parseJson(safeStorageGet(STORAGE_KEY));
    if (!parsed || typeof parsed !== 'object') {
      return {
        params: {},
        landingPath: '',
        landingPageType: '',
        landingArticleHandle: '',
        firstSeenAt: '',
        lastSeenAt: ''
      };
    }
    return {
      params: parsed.params && typeof parsed.params === 'object' ? parsed.params : {},
      landingPath: trimString(parsed.landingPath, 200),
      landingPageType: trimString(parsed.landingPageType, 40),
      landingArticleHandle: trimString(parsed.landingArticleHandle, 80),
      firstSeenAt: trimString(parsed.firstSeenAt, 50),
      lastSeenAt: trimString(parsed.lastSeenAt, 50)
    };
  }

  function writeStoredAttribution(record) {
    safeStorageSet(STORAGE_KEY, JSON.stringify(record));
  }

  function extractTrackedParams(search) {
    var params = {};
    var searchParams;
    try {
      searchParams = new URLSearchParams(search || window.location.search || '');
    } catch (_error) {
      return params;
    }

    TRACKED_QUERY_KEYS.forEach(function (key) {
      var value = trimString(searchParams.get(key), 120);
      if (value) params[key] = value;
    });
    return params;
  }

  function hasAnyKeys(object) {
    var key;
    for (key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) return true;
    }
    return false;
  }

  function getActiveAttribution() {
    var now = new Date().toISOString();
    var stored = readStoredAttribution();
    var currentParams = extractTrackedParams(window.location.search);
    if (!hasAnyKeys(currentParams)) return stored;

    var mergedParams = {};
    var key;
    for (key in stored.params) {
      if (Object.prototype.hasOwnProperty.call(stored.params, key)) {
        mergedParams[key] = stored.params[key];
      }
    }
    for (key in currentParams) {
      if (Object.prototype.hasOwnProperty.call(currentParams, key)) {
        mergedParams[key] = currentParams[key];
      }
    }

    var nextRecord = {
      params: mergedParams,
      landingPath: trimString(window.location.pathname + window.location.search, 200),
      landingPageType: trimString(CONFIG.pageType, 40),
      landingArticleHandle: trimString(CONFIG.articleHandle, 80),
      firstSeenAt: now,
      lastSeenAt: now
    };

    writeStoredAttribution(nextRecord);
    return nextRecord;
  }

  function decorateUrl(rawUrl) {
    var stored = getActiveAttribution();
    var params = stored.params || {};
    var hasStoredParams = hasAnyKeys(params);
    var url;
    var key;
    if (!rawUrl || !hasStoredParams) return rawUrl;
    if (/^(#|mailto:|tel:|javascript:)/i.test(rawUrl)) return rawUrl;

    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (_error) {
      return rawUrl;
    }

    if (url.origin !== window.location.origin) return rawUrl;

    for (key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, params[key]);
      }
    }

    if (/^https?:\/\//i.test(rawUrl)) return url.toString();
    return url.pathname + url.search + url.hash;
  }

  function decorateLink(link) {
    var href = link && link.getAttribute ? link.getAttribute('href') : '';
    var nextHref;
    if (!href) return;
    nextHref = decorateUrl(href);
    if (nextHref && nextHref !== href) {
      link.setAttribute('href', nextHref);
    }
  }

  function decorateExistingLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll ? scope.querySelectorAll('a[href]') : [];
    Array.prototype.forEach.call(links, decorateLink);
  }

  function pushAnalyticsEvent(eventName, params) {
    var payload = params || {};
    publishShopifyCustomerEvent(eventName, payload);
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    payload.event = eventName;
    window.dataLayer.push(payload);
  }

  function publishShopifyCustomerEvent(eventName, params) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    if (!eventName || /:/.test(eventName)) return;

    try {
      analytics.publish('space:' + eventName, params || {});
    } catch (_error) {
      // Customer Events API が使えない環境では静かに諦める。
    }
  }

  function getBaseEventParams() {
    var stored = getActiveAttribution();
    var params = stored.params || {};
    return {
      page_type: trimString(CONFIG.pageType, 40),
      blog_handle: trimString(CONFIG.blogHandle, 80),
      article_handle: trimString(CONFIG.articleHandle, 80),
      landing_path: trimString(stored.landingPath || window.location.pathname, 200),
      landing_page_type: trimString(stored.landingPageType || CONFIG.pageType, 40),
      landing_article_handle: trimString(stored.landingArticleHandle, 80),
      utm_source: trimString(params.utm_source, 80),
      utm_medium: trimString(params.utm_medium, 80),
      utm_campaign: trimString(params.utm_campaign, 80),
      gclid_present: params.gclid ? 'true' : 'false'
    };
  }

  function fireChiikiView() {
    if (CONFIG.pageType !== 'article' || CONFIG.blogHandle !== 'chiiki') return;
    if (safeSessionGet(CHIIKI_VIEW_KEY) === '1') return;
    safeSessionSet(CHIIKI_VIEW_KEY, '1');
    pushAnalyticsEvent('chiiki_lp_view', getBaseEventParams());
  }

  function isChiikiTrackedLink(link) {
    var href = link && link.href ? link.href : '';
    return href.indexOf('utm_source=chiiki-lp') >= 0 || href.indexOf('utm_medium=concierge') >= 0;
  }

  function getQueryParamFromHref(href, key) {
    try {
      return trimString(new URL(href, window.location.origin).searchParams.get(key), 80);
    } catch (_error) {
      return '';
    }
  }

  function normalizePhoneNumber(raw) {
    if (!raw) return '';
    return String(raw).replace(/^tel:/i, '').replace(/[^\d+]/g, '').slice(0, 32);
  }

  function normalizeMailAddress(raw) {
    if (!raw) return '';
    var cleaned = String(raw).replace(/^mailto:/i, '').split('?')[0];
    return trimString(cleaned, 120);
  }

  function sendGoogleAdsConversion(label, extras) {
    var adsId = trimString(CONFIG.googleAdsTagId, 40);
    var adsLabel = trimString(label, 60);
    if (!adsId || !adsLabel || typeof window.gtag !== 'function') return;
    var payload = { send_to: adsId + '/' + adsLabel };
    if (extras && typeof extras === 'object') {
      var key;
      for (key in extras) {
        if (Object.prototype.hasOwnProperty.call(extras, key) && extras[key] != null) {
          payload[key] = extras[key];
        }
      }
    }
    window.gtag('event', 'conversion', payload);
  }

  function firePhoneCtaClick(anchor) {
    var phoneNumber = normalizePhoneNumber(anchor.getAttribute('href'));
    if (!phoneNumber) return;
    if (safeSessionGet(PHONE_CLICK_DEDUP_KEY + ':' + phoneNumber) === '1') return;
    safeSessionSet(PHONE_CLICK_DEDUP_KEY + ':' + phoneNumber, '1');

    var params = Object.assign({}, getBaseEventParams(), {
      phone_number: phoneNumber,
      cta_text: trimString(anchor.textContent, 80),
      cta_path: trimString(window.location.pathname || '', 160)
    });

    pushAnalyticsEvent('phone_cta_click', params);
    sendGoogleAdsConversion(CONFIG.googleAdsPhoneConversionLabel, {
      transaction_id: phoneNumber + ':' + Date.now()
    });
  }

  function fireMailCtaClick(anchor) {
    var mailAddress = normalizeMailAddress(anchor.getAttribute('href'));
    if (!mailAddress) return;
    if (safeSessionGet(MAIL_CLICK_DEDUP_KEY + ':' + mailAddress) === '1') return;
    safeSessionSet(MAIL_CLICK_DEDUP_KEY + ':' + mailAddress, '1');

    var params = Object.assign({}, getBaseEventParams(), {
      mail_address: mailAddress,
      cta_text: trimString(anchor.textContent, 80),
      cta_path: trimString(window.location.pathname || '', 160)
    });

    pushAnalyticsEvent('mail_cta_click', params);
    sendGoogleAdsConversion(CONFIG.googleAdsMailConversionLabel, {
      transaction_id: mailAddress + ':' + Date.now()
    });
  }

  function fireContactFormSubmit(form) {
    var formId = trimString(form.id || form.getAttribute('data-form-id') || form.action || '', 80);
    var dedupKey = FORM_SUBMIT_DEDUP_KEY + ':' + formId;
    if (safeSessionGet(dedupKey) === '1') return;
    safeSessionSet(dedupKey, '1');

    var params = Object.assign({}, getBaseEventParams(), {
      form_id: formId,
      form_type: trimString(form.getAttribute('data-form-type') || 'contact', 40),
      cta_path: trimString(window.location.pathname || '', 160)
    });

    pushAnalyticsEvent('contact_form_submit', params);
    sendGoogleAdsConversion(CONFIG.googleAdsMailConversionLabel, {
      transaction_id: 'form:' + formId + ':' + Date.now()
    });
  }

  function isContactForm(form) {
    if (!form || !form.getAttribute) return false;
    if (form.matches && form.matches('[data-mail-cta], [data-contact-form]')) return true;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/contact') >= 0) return true;
    var type = (form.getAttribute('data-form-type') || form.getAttribute('type') || '').toLowerCase();
    return type === 'contact';
  }

  function handleDocumentClick(event) {
    var intentLink;
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;

    decorateLink(anchor);

    var href = anchor.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      firePhoneCtaClick(anchor);
      return;
    }
    if (/^mailto:/i.test(href)) {
      fireMailCtaClick(anchor);
      return;
    }

    intentLink = anchor.closest('[data-cc-intent]');
    if (intentLink) {
      pushAnalyticsEvent('chiiki_concierge_intent_click', Object.assign({}, getBaseEventParams(), {
        cc_intent: trimString(intentLink.getAttribute('data-cc-intent'), 80),
        cc_label: trimString(intentLink.getAttribute('data-cc-label') || intentLink.textContent, 80)
      }));
      return;
    }

    if (isChiikiTrackedLink(anchor)) {
      pushAnalyticsEvent('chiiki_cta_click', Object.assign({}, getBaseEventParams(), {
        cta_text: trimString(anchor.textContent, 80),
        cta_path: trimString(anchor.pathname || '', 160),
        utm_content: getQueryParamFromHref(anchor.href, 'utm_content')
      }));
    }
  }

  function handleDocumentSubmit(event) {
    var form = event && event.target ? event.target : null;
    if (!form || !form.matches) return;
    if (!isContactForm(form)) return;
    fireContactFormSubmit(form);
  }

  function handlePostalChanged(event) {
    var detail = event && event.detail ? event.detail : {};
    var deliveryProfile = 'unknown';
    var postal = trimString(detail.postal, 20);

    if (window.ChiikiDelivery && typeof window.ChiikiDelivery.getDeliveryProfile === 'function' && postal) {
      try {
        deliveryProfile = trimString(window.ChiikiDelivery.getDeliveryProfile(postal).type, 40) || 'unknown';
      } catch (_error) {
        deliveryProfile = 'unknown';
      }
    }

    pushAnalyticsEvent('chiiki_postal_submit', Object.assign({}, getBaseEventParams(), {
      postal_entered: postal ? 'true' : 'false',
      delivery_profile: deliveryProfile
    }));
  }

  function observeDynamicLinks() {
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) {
            decorateLink(node);
          }
          decorateExistingLinks(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  getActiveAttribution();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      decorateExistingLinks(document);
      fireChiikiView();
      observeDynamicLinks();
    });
  } else {
    decorateExistingLinks(document);
    fireChiikiView();
    observeDynamicLinks();
  }

  document.addEventListener('click', handleDocumentClick, true);
  document.addEventListener('submit', handleDocumentSubmit, true);
  document.addEventListener('chiiki:postal-changed', handlePostalChanged);
})();
